/**
 * Notes shown on invoices: customer delivery_notes + driver completion_notes.
 */
export function getInvoiceDeliveryNotes(job) {
  if (!job) return '';
  const jobNotes = (job.delivery_notes || '').trim();
  const completionNotes = (job.delivery_completion?.completion_notes || '').trim();

  if (jobNotes && completionNotes) {
    if (jobNotes === completionNotes) return jobNotes;
    return `${jobNotes}\n\n${completionNotes}`;
  }
  return jobNotes || completionNotes || '';
}
